import get from 'lodash.get'
export const getStreamId = (props): string | null | undefined => {
  return props.streamId || get(props, 'match.params.streamId', null)
}
